<atlas-modal #modal titleText="User Required">
    <atlas-modal-header>{{title$ | async}}</atlas-modal-header>
    <atlas-modal-content width="550px" maxHeight="400px">
        {{description$ | async}}
    </atlas-modal-content>
    <atlas-modal-footer>
        <atlas-button [text]="button$ | async" (onClick)="closeModal()"></atlas-button>
    </atlas-modal-footer>
</atlas-modal>
